module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-left-6ca4d99249d4581edfad56095542a8f6.svg&quot;;"